import { FormField } from '@/components/custom/erp';
import { Label } from '@/components/ui/label';
import { FormMode } from '@/types/form';

interface BasicInfoTabProps {
  formMode: FormMode;
}

export const BasicInfoTab: React.FC<BasicInfoTabProps> = ({ formMode }) => {
  return (
    <div className='space-y-2 p-4'>
      <div className='space-y-1'>
        <div className='flex items-center'>
          <Label className='w-36 min-w-36'>Mã bộ phận</Label>
          <div className='w-[240px]'>
            <FormField type='text' name='ma_bp' disabled={formMode === 'view'} />
          </div>
        </div>

        <div className='flex items-center'>
          <Label className='w-36 min-w-36'>Tên bộ phận</Label>
          <div className='w-full'>
            <FormField type='text' name='ten_bp' disabled={formMode === 'view'} />
          </div>
        </div>

        <div className='flex items-center'>
          <Label className='w-36 min-w-36'>Tên khác</Label>
          <div className='w-full'>
            <FormField type='text' name='ten_bp2' disabled={formMode === 'view'} />
          </div>
        </div>

        <div className='flex items-center'>
          <Label className='w-36 min-w-36'>Ghi chú</Label>
          <div className='w-full'>
            <FormField type='text' name='ghi_chu' disabled={formMode === 'view'} />
          </div>
        </div>

        <div className='flex items-center'>
          <Label className='w-36 min-w-36'>Trạng thái</Label>
          <div className='w-full'>
            <FormField
              type='select'
              name='status'
              disabled={formMode === 'view'}
              options={[
                { value: '1', label: '1. Còn sử dụng' },
                { value: '0', label: '0. Không sử dụng' }
              ]}
              defaultValue='1'
            />
          </div>
        </div>
      </div>
    </div>
  );
};
